"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.HomeSimilarSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var innerSvg = '<g stroke="none"><path fill-rule="evenodd" d="M13.675 6.551 9.05 2.218a.92.92 0 0 0-1.1 0L3.325 6.551A.91.91 0 0 0 3 7.25v6.874c0 .504.41.913.917.913h9.166a.914.914 0 0 0 .917-.913V7.25a.91.91 0 0 0-.325-.698ZM8.5 5.814 11 8.157v3.879H6v-3.88l2.5-2.342Z" clip-rule="evenodd"></path><path d="m24.05 2.218 4.625 4.333A.91.91 0 0 1 29 7.25v6.874c0 .504-.41.913-.917.913h-9.166a.914.914 0 0 1-.917-.913V7.25a.91.91 0 0 1 .325-.698l4.625-4.333a.92.92 0 0 1 1.1 0Z"></path><path d="M13.675 21.551 9.05 17.218a.92.92 0 0 0-1.1 0l-4.625 4.333A.91.91 0 0 0 3 22.25v6.874c0 .504.41.913.917.913h9.166a.914.914 0 0 0 .917-.913V22.25a.91.91 0 0 0-.325-.698Z"></path><path d="m24.05 17.218 4.625 4.333a.91.91 0 0 1 .325.698v6.874c0 .504-.41.913-.917.913h-9.166a.914.914 0 0 1-.917-.913V22.25a.91.91 0 0 1 .325-.698l4.625-4.333a.92.92 0 0 1 1.1 0Z"></path></g>';
var HomeSimilarSVG = function HomeSimilarSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
exports.HomeSimilarSVG = HomeSimilarSVG;
HomeSimilarSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(HomeSimilarSVG);
exports.default = _default;